module.exports = "pegasus_template/assets/presentation-2-card.png";